<template>
    <div
        class="mx-2 sm:justify-start flex min-h-screen flex-col items-center overflow-hidden bg-[#f4f4f5]"
    >
        <svg
            class="h-75 absolute max-w-[800px]"
            width="800"
            height="75"
            viewBox="0 0 800 75"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_f_307_3481)">
                <ellipse
                    cx="350"
                    cy="77.5"
                    rx="350"
                    ry="77.5"
                    transform="matrix(1 0 0 -1 50 20)"
                    fill="url(#paint0_linear_307_3481)"
                    fill-opacity="0.53"
                />
            </g>
            <g filter="url(#filter1_f_307_3481)">
                <ellipse
                    cx="356"
                    cy="-27"
                    rx="91"
                    ry="36"
                    transform="rotate(-158.473 356 -27)"
                    fill="url(#paint1_linear_307_3481)"
                    fill-opacity="0.8"
                />
            </g>
            <g filter="url(#filter2_f_307_3481)">
                <ellipse
                    cx="512.61"
                    cy="-53.846"
                    rx="91"
                    ry="61"
                    transform="rotate(-26.5088 512.61 -53.846)"
                    fill="url(#paint2_linear_307_3481)"
                    fill-opacity="0.53"
                />
            </g>
            <defs>
                <filter
                    id="filter0_f_307_3481"
                    x="0"
                    y="-185"
                    width="800"
                    height="255"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation="25"
                        result="effect1_foregroundBlur_307_3481"
                    />
                </filter>
                <filter
                    id="filter1_f_307_3481"
                    x="216.311"
                    y="-128.292"
                    width="279.378"
                    height="202.583"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation="27"
                        result="effect1_foregroundBlur_307_3481"
                    />
                </filter>
                <filter
                    id="filter2_f_307_3481"
                    x="372.723"
                    y="-175.89"
                    width="279.774"
                    height="244.088"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation="27"
                        result="effect1_foregroundBlur_307_3481"
                    />
                </filter>
                <linearGradient
                    id="paint0_linear_307_3481"
                    x1="23.0769"
                    y1="57.4863"
                    x2="47.2857"
                    y2="204.76"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#FF9548" />
                    <stop
                        offset="0.515625"
                        stop-color="#FF176B"
                        stop-opacity="0.76"
                    />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_307_3481"
                    x1="271"
                    y1="-36.2967"
                    x2="289.996"
                    y2="28.3842"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#FF9548" />
                    <stop
                        offset="0.515625"
                        stop-color="#FF176B"
                        stop-opacity="0.76"
                    />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_307_3481"
                    x1="427.61"
                    y1="-69.5987"
                    x2="475.094"
                    y2="25.8229"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#FF9548" />
                    <stop
                        offset="0.515625"
                        stop-color="#FF176B"
                        stop-opacity="0.76"
                    />
                </linearGradient>
            </defs>
        </svg>

        <div class="flex flex-col items-center">
            <slot name="logo" />
        </div>

        <div
            class="mt-6 rounded-xl px-2 py-3 sm:p-8 w-full bg-[#fcfcfc]"
            style="box-shadow: 0px 0px 10px 0px rgba(16, 24, 40, 0.05)"
            :class="cardWidthClass"
        >
            <slot />
        </div>

        <div>
            <slot name="under" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps<{
    cardSize?: "md" | "lg" | "xl";
}>();

const cardWidthClass = computed(() => {
    if (props.cardSize === "xl") {
        return "sm:max-w-xl";
    }
    if (props.cardSize === "lg") {
        return "sm:max-w-lg";
    }
    return "sm:max-w-md";
});
</script>
